import React from 'react';
import { InputType } from '../Form/InputType';
import { RowType } from '../Form/RowType';
import { Translate } from '@above-the-treeline/localization';

export const getInitialFormValuesById = userAttributes => {
	const dataKeyByInputId = {
		uriPersonal: 'Personal Website Uri',
		uriFacebook: 'Facebook Uri',
		uriTwitter: 'Twitter Uri',
		uriLinkedIn: 'LinkedIn Uri',
		uriGoodreads: 'Goodreads Uri',
		uriSkype: 'Skype Uri',
	};

	let initialFormValuesById = {};

	for (const inputId in dataKeyByInputId) {
		const dataKey = dataKeyByInputId[inputId];

		initialFormValuesById[inputId] =
			userAttributes && userAttributes[dataKey]
				? userAttributes[dataKey].Value
				: '';
	}

	return initialFormValuesById;
};

export const getRowOptionsList = () => {
	const rowOptionsList = [
		getSocialMediaLinkRowOptions(
			<Translate id="blog_personal" />,
			'uriPersonal',
			'icon-ios-body',
		),
		getSocialMediaLinkRowOptions(
			'Facebook',
			'uriFacebook',
			'icon-facebook-icon',
		),
		getSocialMediaLinkRowOptions(
			'Twitter',
			'uriTwitter',
			'icon-twitter-icon',
		),
		getSocialMediaLinkRowOptions(
			'LinkedIn',
			'uriLinkedIn',
			'icon-linkedin-alt',
		),
		getSocialMediaLinkRowOptions(
			'Goodreads',
			'uriGoodreads',
			'icon-goodreads',
		),
		getSocialMediaLinkRowOptions('Skype', 'uriSkype', 'icon-skype'),
	];

	return rowOptionsList;
};

const getSocialMediaLinkRowOptions = (label, inputId, iconCssClass) => {
	return {
		rowType: RowType.SocialMediaLinkInputRow,
		rowTypeData: {
			label: label,
			inputId: inputId,
			inputType: InputType.TextInput,
			iconCssClass: iconCssClass,
		},
	};
};
